import { createEvent, restore, sample } from 'effector'
import { $params } from '../../../../../features/router'
import {
  RangeValue,
  TransactionsDetailsItemFromServer,
  TransactionsDetailsRequest,
  TransactionsDetailsResponse,
} from '../TransactionsDetails/types'
import { changedDateFormat } from '../../../../../libs/utils'
import { fx } from '../../../../../libs'

export const FilterEvent = createEvent<TransactionsDetailsRequest>()

export const getTransactionsDetails = fx<void, TransactionsDetailsResponse>({
  method: 'GET',
  url: '/finance/wallet/{walletID}/transaction',
})

export const $transactionsDetails = restore<
  TransactionsDetailsItemFromServer[]
>(
  getTransactionsDetails.doneData.map((a) => a.body.items),
  [],
)

sample({
  // @ts-ignore
  clock: FilterEvent,
  source: $params,
  fn: (
    params,
    { limit, page, searchText, filters, orderBy, orderDirection },
  ) => {
    let filtersTransactionsParams = {}

    let query = {
      limit,
      page,
    }

    if (orderBy && orderDirection) {
      // @ts-ignore
      query['order'] = `${orderDirection === 'asc' ? '' : '-'}${orderBy}`
    }

    if (filters) {
      //TODO данные мапперы необходимо переписать, когда бэк будет паринимать правильный JSON
      filtersTransactionsParams = Object.keys(filters).reduce(
        (accumulator, key) => {
          if (filters[key as keyof typeof filters] != null) {
            if (key === 'currency' || key === 'gateways' || key === 'type') {
              accumulator[key as keyof typeof filters] =
                filters[key as keyof typeof filters]
            } else if (key === 'period') {
              if ((filters[key as keyof typeof filters] as RangeValue)[0]) {
                accumulator['dateFrom'] = changedDateFormat(
                  //@ts-ignore
                  (filters[key as keyof typeof filters] as RangeValue)[0],
                )
              }
              if ((filters[key as keyof typeof filters] as RangeValue)[1]) {
                accumulator['dateTo'] = changedDateFormat(
                  //@ts-ignore
                  (filters[key as keyof typeof filters] as RangeValue)[1],
                )
              }
            } else {
              accumulator[key as keyof typeof filters] = `${
                filters[key as keyof typeof filters]
              }`
            }
          }

          return accumulator
        },
        {} as any,
      )
    }

    if (searchText) {
      filtersTransactionsParams = {
        ...filtersTransactionsParams,
        id: searchText,
      }
    }

    if (Object.keys(filtersTransactionsParams).length) {
      // @ts-ignore
      query['where'] = `${JSON.stringify(filtersTransactionsParams)}`
    }

    return {
      url: `/finance/wallet/${params?.walletID}/transaction`,
      query,
    }
  },
  target: getTransactionsDetails,
})
